import type { Component } from "solid-js";
import Iconalfa from "~/Icons/testimonials/alfa.svg?component-solid";
import IconBBE from "~/Icons/testimonials/BBE.svg?component-solid";
import Iconfonbet from "~/Icons/testimonials/fonbet.svg?component-solid";
import IconMTC_Log from "~/Icons/testimonials/MTC_Log.svg?component-solid";
import Icons from "~/solidJs/shared/ui/atoms/IconsComp";

export const Testimonials: Component = () => {
	return (
		<div class="custom-tw-hidden flex flex-col items-center gap-8 md:flex">
			<div class="caption-12-medium text-text-secondary-v2">Loved by teams at</div>
			<div class="flex w-full items-center justify-center gap-9">
				<IconBBE />
				<Iconfonbet />
				<Iconalfa />
				<Icons.BHSD.default />
				<IconMTC_Log />
			</div>
		</div>
	);
};
